import { featureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Service from '../Service';
import gateway from '../Gateway';

const version = isProdVersion()
  ? featureFlagFlags.DbManagerServiceVersionProd.getValue()
  : featureFlagFlags.DbManagerServiceVersionStaging.getValue();

const afterParser = (response) => response;

class DbManagerService extends Service {
  constructor(gateway, version) {
    const api = createApi(`benchmarks-db-manager/${version}/`, gateway);

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  getPlans(params = {}, userGroup) {
    return this.find({
      params,
      url: `plans/${userGroup}/benchmarks/`,
    });
  }

  getPageGroups(params = {}, benchmarkId) {
    return this.find({
      params,
      url: `benchmarks/${benchmarkId}/page-groups`,
    });
  }

  getChannels(params = {}) {
    return this.find({
      params,
      url: 'channels',
    });
  }

  getColors(params = {}) {
    return this.find({
      params,
      url: 'colors',
    });
  }

  getBenchmarksList(params = {}) {
    return this.find({
      params,
      url: 'benchmarks',
    });
  }

  updateBenchmarks({ expiryDate, id }) {
    return this.api.patch({
      expiryDate,
      url: `benchmarks/${id}`,
    }).then(this.afterParser);
  }
}

export default new DbManagerService(gateway, version);
